"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Banner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_icons_1 = require("@radix-ui/react-icons");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var IconContainer = (0, stitches_config_1.styled)("div", {
    "& *": {
        verticalAlign: "text-bottom",
    },
});
var StyledBanner = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: "8px 12px",
    gap: 8,
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    variants: {
        fullWidth: {
            true: {
                width: "100%",
            },
        },
        variant: {
            neutral: {
                background: stitches_config_1.theme.colors.gray3,
            },
            success: {
                background: stitches_config_1.theme.colors.green3,
            },
            warning: {
                background: stitches_config_1.theme.colors.yellow3,
            },
            error: {
                background: stitches_config_1.theme.colors.red3,
            },
        },
    },
    defaultVariants: {
        variant: "neutral",
    },
    width: "fit-content",
});
var TextContainer = (0, stitches_config_1.styled)("div", {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
});
function getIcon(variant) {
    if (variant === "success") {
        return (0, jsx_runtime_1.jsx)(react_icons_1.CheckCircledIcon, {});
    }
    if (variant === "error") {
        return (0, jsx_runtime_1.jsx)(react_icons_1.ExclamationTriangleIcon, {});
    }
    if (variant === "warning") {
        return (0, jsx_runtime_1.jsx)(react_icons_1.ExclamationTriangleIcon, {});
    }
    else {
        return (0, jsx_runtime_1.jsx)(react_icons_1.InfoCircledIcon, {});
    }
}
function Banner(props) {
    return ((0, jsx_runtime_1.jsxs)(StyledBanner, __assign({ variant: props.variant, fullWidth: props.fullWidth }, { children: [!props.hideIcon && ((0, jsx_runtime_1.jsx)(IconContainer, { children: getIcon(props.variant) })), (0, jsx_runtime_1.jsxs)(TextContainer, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.message })), props.body && (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm" }, { children: props.body }))] })] })));
}
exports.Banner = Banner;
//# sourceMappingURL=Banner.js.map